<template>
  <div>

    <v-dialog v-model="confirmDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{isEdit?"Update this post?":"Post new information?"}}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="confirmDialog = false">Cancel</v-btn>
          <v-btn v-if='isEdit' color="red darken-1" text @click="update">OK</v-btn>
          <v-btn v-else color="red darken-1" text @click="create">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="value" persistent max-width="800px">
      <v-card id=create-marker-container>
        <v-card-title>
          <span class="headline">{{isEdit?"Edit Post":"New Post"}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="title" label="Title" prepend-icon="mdi-format-title" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <MarkerImageUploader ref="marker_image_uploader" v-model="markerImage" :oldMarkerUrl="oldMarkerUrl"/>
              </v-col>
              <v-col cols="12">
                <span class="headline">Public</span>
                <ContentEditor v-model="description" ref="editor"/>
              </v-col>
              <v-col cols="12">
                <span class="headline">Private</span>
                <ContentEditor v-model="description_private" ref="editor_private"/>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="close">Cancel</v-btn>
          <v-btn v-if="isEdit" color="red darken-1" text @click="confirmDialog=true">OK</v-btn>
          <v-btn v-else color="red darken-1" text @click="confirmDialog=true">OK</v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {db, GeoPoint, FieldValue} from '@/firebase'
import MarkerImageUploader from "./MarkerImageUploader"
import ContentEditor from "./ContentEditor"

export default {
  name: "CreateMarkerDialog",
  components: {
    MarkerImageUploader,
    ContentEditor,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    latLng: {
      type: Object
    },
    marker: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      title: "",
      markerImage: null,
      description: "",
      description_private: "",
      confirmDialog: false,
      isPublic: false,
      oldMarkerUrl: null,
    };
  },
  computed: {
    open: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue);
      }
    },
  },
  watch: {
    open: function(newValue, oldValue){
      if (newValue) {
        if (this.marker) {
          this.title = this.marker.title;
          this.isPublic = this.marker.public;
          this.description = this.marker.description;
          if (this.$refs.editor) {
            this.$refs.editor.setContent(this.marker.description);
          }
          this.description_private = this.marker.description_private;
          if (this.$refs.editor_private) {
            this.$refs.editor_private.setContent(this.marker.description_private);
          }
          this.oldMarkerUrl = this.marker.markerImage;
        }
      } 
    },
  },
  methods: {
    create() {
      db.collection('markers').add({
        title: this.title,
        description: this.description,
        description_private: this.description_private,
        location: new GeoPoint(this.latLng.lat, this.latLng.lng),
        createdBy: this.$store.getters.userData,
        markerImage: this.markerImage,
        createdAt: FieldValue.serverTimestamp(),
        //public: this.isPublic,
      }).then(function(result) {
      }).catch(function(error) {
        console.log(error);
      });
      this.close();
    },
    update() {
      let that = this;
      const a = db.collection('markers').doc(this.marker.id).update({
        title: this.title,
        description: this.description,
        description_private: this.description_private,
        markerImage: this.markerImage?this.markerImage:this.oldMarkerUrl,
        updatedAt: FieldValue.serverTimestamp(),
        //public: this.isPublic,
      }).then(function(result) {
        that.close();
        that.$emit('updated');
      }).catch(function(error) {
        console.log(error);
      });
    },
    close() {
      this.title = "";
      this.markerImage = null;
      this.description = "";
      this.description_private = "";
      this.$refs.editor.clearContent()
      this.$refs.editor_private.clearContent()
      this.confirmDialog = false;
      this.open = false;
      this.$refs.marker_image_uploader.clearAttachImg();
      this.$emit('close');
    },
  }
};
</script>

<style>
#create-marker-container {
  background: black;
}
#create-marker-container *{
  color: red;
  border-color: red;
}

#create-marker-container .red--text {
  background: red;
}
#create-marker-container .red--text *{
  color: black;
}
</style>
